import React, { useState, useEffect, useCallback } from "react";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../../utils/constants";
import SimplePagePagination from "../../../commons/Pagination/SimplePagePagination";

const RejectedRestaurant = () => {
  const [loading, setLoading] = useState(false);
  const [restaurants, setRestaurants] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getRestaurants = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: 10,
        approval_status: "rejected",
        // approval_status: 2,
        ...(searchTerm && { search: searchTerm }),
      });

      const response = await handleApiCall("get", `${endpoints.restaurantList}?${params}`);
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const restaurantData = response?.data?.data?.data || [];
        // Additional client-side filtering to ensure only approval_status: 2
        // const filteredRestaurants = restaurantData.filter((restaurant) => restaurant.approval_status === 2);
        // setRestaurants(filteredRestaurants);
        setRestaurants(restaurantData);
        setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
      } else {
        toast.error(response?.data?.message || "Failed to fetch rejected restaurants");
      }
    } catch (error) {
      console.error("Error fetching rejected restaurants:", error);
      toast.error("Failed to fetch rejected restaurants");
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm]);

  useEffect(() => {
    getRestaurants();
  }, [getRestaurants]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      {/* Search Bar */}
      <div className="row mb-4 mx-0 px-0">
        <div className="col-md-6 px-0">
          <div className="form-group my-0">
            <input type="text" className="form-control search-icon left-icon border" placeholder={UI_CONSTANTS.PLACEHOLDERS.RESTAURANT_SEARCH} value={searchTerm} onChange={handleSearch} />
          </div>
        </div>
      </div>

      <div className="table-responsive px-0">
        <table className="table table-striped trim">
          <thead>
            <tr>
              <th width="80">Restaurant ID</th>
              <th width="150">Restaurant Name</th>
              <th>Owner/Manager Name</th>
              <th>Email id</th>
              <th>Mobile Number</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : restaurants.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                </td>
              </tr>
            ) : (
              restaurants.map((restaurant, index) => (
                <tr key={restaurant._id}>
                  <td>#{restaurant._id.slice(-8)}</td>
                  <td>{restaurant.restaurant_id?.restaurant_name || "N/A"}</td>
                  <td>{restaurant.restaurant_id?.full_name || "N/A"}</td>
                  <td>{restaurant.restaurant_id?.email || "N/A"}</td>
                  <td>{restaurant.restaurant_id?.phone ? `+${restaurant.restaurant_id.phone}` : "N/A"}</td>
                  <td>
                    <span className="badge badge-danger">Rejected</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <SimplePagePagination page={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
    </>
  );
};

export default RejectedRestaurant;
